let szenedata = 4;
import { sitePos } from "./sitepos";

sitePos(szenedata);